import {PublicKey} from "@solana/web3.js";

export const AGENT_PROGRAM = new PublicKey("agnmDKzZkv63sRhPFvm3iWpxaopgTRcohXA6CSYSXvQ");
export const LLM_PROGRAM = new PublicKey("LLMrieZMpbJFwN52WgmBNMxYojrpRVYXdC1RCweEbab");